import React, { useEffect, useState, useRef } from 'react';

function PlaForm({id, ai}) {
  
  const idInputRef = useRef(null); 
  
  useEffect(() => {
  if (idInputRef.current) {
    console.log("Referência inicializada:", idInputRef.current);
  }
  }, []);

  const handleFocus = () => {
  if (idInputRef.current) {
    idInputRef.current.focus();
  } else {
    console.log("Referência não está disponível!");
  }
  };

  const [formData, setFormData] = useState({
  id: ""
  });

  formData.codigo = id;

  const handleChange = (e) => {
  const { name, value, checked, type } = e.target; 
  setFormData({ ...formData, [name]: type === "checkbox" ? checked : value});
  setFormData((prevData) => ({
    ...prevData,
    [name]: value
    

  }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  const params = new URLSearchParams();
  for (const key in formData) {
    if (key === "Situacao")  {
    if (formData[key] === "") {
      formData[key] = "Ativo"; }};
    params.append(key, formData[key]);
  }
  console.log('params----->', params, formData);

  if (!id) {
    id = formData.id;
  }
   
  const response = await fetch(`http://localhost:3001/cr_pag_Id/${id}/${ai}`, {
    method: "PUT",
    headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData),
  });
  if (response.status === 200) {
    window.location.href = "./PagGrid";
  } else {
    console.error('Erro ao ATUALIZAR cliente:', response.status);
    alert('Erro ao ATUALIZAR-POST Cr_Pag.'+response.status);
  }
  const data = await response.json();
  };

  useEffect(() => {
  if (ai ==="I") {
    fetch("http://localhost:3001/cr_cont?id=pag")
    .then((response) => { if (!response.ok) {throw new Error("Erro ao buscar os dados!");}
    return response.json();})
    .then((data) => { formData.id = data.cr_cont.id; 
     })
    .catch((error) => console.error("Erro ao buscar os dados:", error));
  }
  }, [id, ai, formData]);

  useEffect(() => {
    fetch(`http://localhost:3001/cr_pag_Id?id=${id}`)
      .then(response => {
        if (!response.ok) {
        throw new Error("Erro ao buscar os dados!");
        }
        return response.json();
      })
      .then(data => {
        setFormData(prevState => ({ ...prevState, 
        id:data.cr_pag.id
        })); 
      })
      .catch(error => console.error("Erro ao buscar os dados:", error));
    }, [id, ai] );

  //handleFocus();

return (
<><div class="areabox">
  <br/>

<table border={2}>

<tr>
<th >        <label for="numero" class="form-control">Número:</label><br/>  
        <input type="text" class="w15 fs1" id="numero" name="numero"  value={formData.id} onChange={handleChange}  />
 </th>
</tr>
<tr>
<th >        <label for="id" class="form-control">Código:</label><br/>  
        <input type="text" class="w15 fs1" id="id" name="id"  value={formData.id} onChange={handleChange}  />
 </th>
</tr>
<tr>
<th >
<label for="nome" class="form-control ">Nome do Plano de Conta :</label><br/>      
        <input type="text" class="w45 fs1" id="nome" name="nome" value={formData.nome} onChange={handleChange} ref={idInputRef}/>


</th>
</tr>
<tr>
<th >
<label class="form-control">Tipo:</label><br/>
<input type="radio" id="sintetico" name="tipo" value="S" checked={formData.iat==='S'} onChange={handleChange}/><label for="sintetico" class="form-control">Sintético (Titulos)</label><br/>
<input type="radio" id="analitico" name="tipo" value="A" checked={formData.iat==='A'} onChange={handleChange}/><label for="analitico" class="form-control">Analítico (Lançamentos)</label><br/>


</th>
</tr>
<tr>
<th >
<input type="checkbox" id="ativo"      name="ativo"      checked={formData.ativo} onChange={handleChange}/>
      <label for="ativo" class="form-control">Ativo</label><br/>

</th>
</tr>

</table>


  <br/>
  <button type="submit" class="botaovermelho">Confirmar</button>
  <button type="button" className="botaocinza" onClick={() => {window.location.href = "./PlaGrid"; }}>Cancelar</button>&nbsp;
</div></>
)    
};

export default PlaForm;

